module.exports = __webpack_public_path__ + "img/icon-cart.369779e8.svg";